export class ChristieSecure {
    constructor(socket, log) {
        this.socket = socket;
        this.power = false;
        this.videoSelection = '0';
        this.volume = 50;
        this.volumeMute = false;
        this.asyncHandlers = [
            {
                name: 'powerQuery',
                regExp: /K:ALLPWR\?/i,
                callback: (match) => {
                    // 0 is power on, 1 is power off (power save), 2 is off (RS232, remote control off)
                    this.socket.send(`ALL:PWR=00${this.power ? '0' : '1'}`);
                },
            },
            {
                name: 'powerSet',
                regExp: /K:ALLPO(N|F)/i,
                callback: (match) => {
                    this.power = match[1].toUpperCase() === 'N';
                    this.socket.send(`ALL:PO${match[1]}=A`);
                },
            },
            {
                name: 'videoQuery',
                regExp: /K:ALLSRC\?+/i,
                callback: (match) => {
                    this.socket.send(`ALL:SRC=${this.videoSelection.padStart(3, '0')}`);
                },
            },
            {
                name: 'videoSet',
                regExp: /K:ALLSH(\d+)/i,
                callback: (match) => {
                    this.videoSelection = match[1];
                    this.socket.send(`ALL:SH${this.videoSelection}=A`);
                },
            },
            {
                name: 'volumeMuteQuery',
                regExp: /K:ALLMUT\?/i,
                callback: (match) => {
                    this.socket.send(`ALL:MUT=00${this.volumeMute ? '1' : '0'}`);
                },
            },
            {
                name: 'volumeMuteSet',
                regExp: /K:ALLMO(N|F)/i,
                callback: (match) => {
                    this.volumeMute = match[1].toUpperCase() === 'N';
                    this.socket.send(`ALL:MO${match[1]}=A`);
                },
            },
            {
                name: 'volumeQuery',
                regExp: /K:ALLVOL\?+/i,
                callback: (match) => {
                    this.socket.send(`ALL:VOL=${this.volume.toString().padStart(3, '0')}`);
                },
            },
            {
                name: 'volumeSet',
                regExp: /K:ALLVOL(\d+)/i,
                callback: (match) => {
                    this.volume = parseInt(match[1], 10);
                    this.socket.send('ALL:VOL=A');
                },
            },
        ];
        // Commands are terminated with a ? for queries or . for sets
        this.commandExtractor = {
            terminators: [],
            unterminatedRegExp: /K:ALL.{3,7}[\?\.]/,
        };
        this.sendTerminator = '';
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            const code = videoInput.code;
            if (this.videoSelection === code)
                return;
            if (lowestCode === undefined || parseInt(code, 10) < parseInt(lowestCode, 10)) {
                lowestCode = code;
            }
        }
        this.videoSelection = lowestCode !== null && lowestCode !== void 0 ? lowestCode : '0';
    }
}
ChristieSecure.emulatorType = 'socketEmulator';
ChristieSecure.key = '-Ng01CvV1qprIOJ61YoC';
